export default __webpack_public_path__ + "static/media/White-pen.abc1b343.svg";